"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.novasolPopularFeatureIds = exports.cottagesPopularFeatureIds = exports.hoseasonsPopularFeatureIds = void 0;
exports.hoseasonsPopularFeatureIds = [
    '10091',
    '6392',
    '6464',
    '9153',
    '9244',
    '6455',
    '9161',
    '6948',
    '2562',
    '9857',
    '3084',
    '3070',
    '3032',
    '3050',
    'ent_petsallowed',
    'ent_wifiac',
    'ent_hottubprivate',
    'ent_swimmingpool',
    'ent_beach',
    'ent_familyentertainment',
    'ent_luxurycollection',
];
exports.cottagesPopularFeatureIds = [
    '10091',
    '6392',
    '6464',
    '9153',
    '9244',
    '6455',
    '9161',
    '6948',
    '2562',
    '9857',
    '3084',
    '3070',
    '3032',
    '3050',
    'ent_wifiac',
    'ent_petsallowed',
    'ent_pub',
    'ent_coastalwithin5miles',
    'ent_enclosedgardenpatio',
    'ent_openfirewoodburningstove',
    'ent_luxurycollection',
    'ent_hottubprivate',
    'ent_swimmingpool',
];
exports.novasolPopularFeatureIds = [
    'FILT-1',
    'FILT-3',
    'FILT-4',
    'FILT-5',
    'FILT-31',
    'FILT-9',
    'FILT-10',
    'FILT-27',
    'FILT-7',
    'FILT-13',
    'FILT-18',
    'ent_coastalwithin5miles',
    'ent_swimmingpool',
    'ent_holidayhome',
    'ent_petsallowed',
    'ent_aircon',
    'ent_sauna1',
    'ent_hottubprivate',
    'ent_freecancellation',
    'ent_luxurycollection',
    'ent_wifiac',
];
//# sourceMappingURL=popularFeatures.js.map